<template>
    <div class="product-detail-attribute-container">
        <div v-for="(value, key, i) in product.product_details_attributes" :key="key">
           <div class="attribute" :class="[{'border' : i % 2 != 0 && !product_on_popout}, {'border-on-modal' : i % 2 != 0 && product_on_popout}]" >
                <div class="attribute-name">{{ key }}</div>
                <div class="attribute-value">{{ value }}</div>
           </div>
        </div>
    </div>
</template>
<script> 
export default {
    props: ['product', 'product_on_popout']
}
</script>
<style lang="scss" scoped>
.product-detail-attribute-container{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0px 24px;

    @media(max-width: 1290px){
        grid-template-columns: repeat(1, 1fr);
    }
    
    @container(max-width: 1000px){ //This is for opening on modal inside wineclub list etc
        grid-template-columns: repeat(1, 1fr);
    }
}
.attribute{
    display: flex;
    justify-content: space-between;
    width: 400px;
    padding-bottom: 16px;

    @media(max-width:507px) {
        width: 310px;
    }
}

.attribute.border{
    @media(min-width: 1290px){
        border-left: 1px solid hsl(from var(--maj-slate) h s l / 0.5);
        padding-left: 24px;
    }

}
.attribute.border-on-modal{
    @container(width > 1000px){ //This is for opening on modal inside wineclub list etc
       border-left: 1px solid hsl(from var(--maj-slate) h s l / 0.5);
        padding-left: 24px;
    }
}

.attribute-name{
    font-size: 1.01rem;
    font-weight: 600;
    line-height: 23px;
    text-transform: uppercase;
}
.attribute-value{
    font-size: 1.01rem;
    line-height: 23px;
}
</style>